// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xScreen } from "@eisinc/XDL/Utilities";
import { availabilityStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAvailability";
import { css } from "styled-components";

availabilityStyles.availability = {
    container: {
        css: css`
            ${xScreen("lte", "sm")`
                display: flex;
                flex-direction: row;
                align-items: center;
                margin-top: 5px;
                margin-bottom: 5px;
            `}
        `,
    },
};
